import type { PatientData } from '../models';

/**
 * Checks if conditional fields should be shown based on patient data
 */
export const shouldShowConditionalFields = (patientData?: PatientData): boolean => {
  return patientData?.sexuality === 'K' || patientData?.sexuality === 'KADIN';
};

